export const tr = {
    accept: 'Uygula',
    back: 'Geri',
    rest: '{count} daha yazdırmaya devam edin'
};
